var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.61491 0.392901C4.41395 0.593864 4.29085 0.873133 4.29124 1.17983V1.31482C4.29124 1.929 4.78845 2.4262 5.40184 2.42541H11.4702L1.20489 12.6907C0.771356 13.1243 0.771356 13.828 1.20489 14.2615C1.63843 14.6951 2.34214 14.6951 2.77568 14.2615L13.041 3.9962V10.0646C13.041 10.6788 13.5382 11.176 14.1516 11.1752H14.2866C14.9008 11.1752 15.398 10.678 15.3972 10.0646V1.17983C15.3972 0.565651 14.9 0.0684482 14.2866 0.0692336L5.40184 0.0692336C5.09475 0.0692335 4.81587 0.191939 4.61491 0.392901Z",
    fill: "#34C759"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenArrow);
export default __webpack_public_path__ + "static/media/green-arrow.aa509e0cbbfc9cd209b10810b3be3952.svg";
export { ForwardRef as ReactComponent };